import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';

// Import TranslationModule if needed
// import { TranslationModule } from '../translation/translation.module';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        // TranslationModule
    ],
    providers: [
        // API services will be added here
        // HTTP interceptors will be added here
    ],
})
export class CoreModule {
    // Prevent CoreModule from being imported multiple times
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
        }
    }
}
